/**
 * UN/LOCODE → City name lookup for shipping ports.
 *
 * Data source: UNECE 2024-2 UN/LOCODE dataset (17,500+ sea ports)
 * generated via `npx tsx scripts/generate-sea-ports.ts` from
 * the @geoapify/un-locode package, merged with carrier-standard
 * overrides for codes that differ from the official dataset
 * (e.g. CNSHA for Shanghai, KRBUS for Busan).
 */

import seaPorts from '@/data/sea-ports.json';

export const UN_LOCODE_NAMES: Record<string, string> = seaPorts;

/**
 * Returns a city-level display name for a UN location code, or null if unknown.
 */
export function getPortName(unLocationCode: string): string | null {
  return UN_LOCODE_NAMES[unLocationCode.toUpperCase()] ?? null;
}
